<div class="full-height notranslate">
  <ng-container *ngIf="!isTestStarted && !isTestExampleStarted && booking">
    <gast-onset-cloze-test-introduction [title]="startPageTitle" [subtitle]="startPageSubtitle"
      [totalExercise]="booking?.numAufgaben" [currentExcerciseNumber]="currentExercise" [content]="startPageContent"
      [clozeTestStyleModel]="clozeTestStyleModel" [cTestLogo]="cTestLogo" [cTestButtonColor]="cTestButtonColor"
      [mobileMode]="mobileMode" (startTest)="onStartTest($event)" (startTestExample)="onStartTestExample()">
    </gast-onset-cloze-test-introduction>
  </ng-container>

  <ng-container *ngIf="!isTestStarted && booking && isTestExampleStarted">
    <gast-cloze-test-exercise-example [clozeTestStyleModel]="clozeTestStyleModel" [cTestLogo]="cTestLogo" [lang]="lang"
      [cTestButtonColor]="cTestButtonColor" (startTest)="onStartTest($event)">
    </gast-cloze-test-exercise-example>
  </ng-container>

  <ng-container *ngIf="isTestStarted && !isTestOver">
    <gast-onset-cloze-test-exercise [title]="exerciseTitle" [content]="exerciseContent"
      [isLastExercise]="isLastExercise" [currentExcerciseNumber]="currentExercise" [lastExerciseNumber]="lastExcercise"
      [totalExercise]="booking?.numAufgaben" [clozeTestStyleModel]="clozeTestStyleModel" [bookingId]="booking.buchungId"
      [exerciseId]="exerciseId" [cTestLogo]="cTestLogo" [cTestButtonColor]="cTestButtonColor" [mobileMode]="mobileMode"
      (nextExercise)="onNextExercise($event)" (endTest)="onTestEnd($event)"></gast-onset-cloze-test-exercise>
  </ng-container>

  <ng-container *ngIf="isTestOver && !showGerInfo">
    <gast-cloze-test-result [results]="results" [showResult]="showResult" [clozeTestStyleModel]="clozeTestStyleModel"
      [totalExercise]="booking?.numAufgaben" [currentExcerciseNumber]="currentExercise" [cTestLogo]="cTestLogo"
      [cTestButtonColor]="cTestButtonColor" [mobileMode]="mobileMode" [showEndTestButton]="showEndTestButton" (clozeTest)="onClozeTest($event)"
      (gerInfo)="onGerInfoClick()">
    </gast-cloze-test-result>
  </ng-container>

  <ng-container *ngIf="isTestOver && showGerInfo">
    <gast-cloze-test-ger-info [clozeTestStyleModel]="clozeTestStyleModel" [cTestLogo]="cTestLogo"
      [cTestButtonColor]="cTestButtonColor" [mobileMode]="mobileMode"></gast-cloze-test-ger-info>
  </ng-container>
</div>
